import React, {Component} from 'react';
import {connect} from 'react-redux';

import Box from 'components/box';
import Input from 'form/input';
import Textarea from 'form/textarea';
import Checkbox from 'form/checkbox';
import {Error} from 'components/errors';
import {Label, SelectWrapperAdmin, Divider, SelectWithSearch, SelectWithSearchAsync, RequiredSpan} from 'components/common';
import {PageHead} from 'components/header/components';
import {ButtonDefault} from 'components/buttons';
import Spinner from 'spinner';
import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import {searchMedicalInstitutions} from 'redux/actions/portal/institutions';
import {changePersonalValue, submitNewPersonal, personalCleanStore, loadPersonalDetail, personalCreateFailed} from 'redux/actions/admin/personal';
import {searchDoctors} from 'redux/actions/admin/doctors'
import {any, assocPath, compose, map, mapObjIndexed, not, path, pick, values} from "ramda";

import close from 'images/general/close.svg';

const mapStateToProps = (state) => ({
  personalDetail: state.adminPersonal.get('personalItem'),
  item: state.adminPersonal.get('personalItem'),
  doctors: state.doctors.get('doctorsList'),
  institutions: state.institutions.get('institutionsList'),
  isSubmitting: state.adminPersonal.get('personalIsSubmitting'),
  hasError: state.adminPersonal.get('personalCreateFailed')
});

const mapDispatchToProps = (dispatch) => ({
  onValueChange: (value, key) => {
    dispatch(changePersonalValue(value, key))
  },
  loadPersonalDetail: (id) => dispatch(loadPersonalDetail(id)),
  loadInstitutions: search => dispatch(searchMedicalInstitutions(search)),
  loadDoctorList: search => dispatch(searchDoctors(search, '', '')),

  submitNewPersonal: (personalData, id) => dispatch(submitNewPersonal('/admin/personal/detail/', personalData, id)),
  cleanPersonalDetail: () => dispatch(personalCleanStore()),
  cleanError: () => dispatch(personalCreateFailed(false))
});

class CreatePersonal extends Component {

  state = {
    personalData: {
      institution: '',
      doctor: '',
      personal_type: '',
      position_title: '',
      cabinet_number: '',
      schedule: '',
      comment: '',
      phone: '',
      sort_priority: null,
      is_responsible: false,
      is_admin: false,
      is_manager_document: false,
      is_operator: false,
      is_manager_institution: false,
      is_registry: false
    },
    errors: {
      institution: false,
      doctor: false,
      personal_type: false,
      position_title: false,
      cabinet_number: false,
      schedule: false,
      comment: false,
      phone: false,
      sort_priority: false,
      is_responsible: false,
      is_admin: false,
      is_manager_document: false,
      is_operator: false,
      is_manager_institution: false,
      is_registry: false
    },
    formValid: true, 
    modalOpen: false,
    isEditMode: false,
    personalSelect: '',
    institutionSelect: '',
    editedSelect: false
  }

  selectPersonalStyle = () => ({
    border: path(['errors', 'doctor'], this.state) ? "solid 1px #7f1414" : "none"
  })

  selectTypeStyle = () => ({
    border: path(['errors', 'personal_type'], this.state) ? "solid 1px #7f1414" : "none"
  })

  selectInstitutionStyle = () => ({
    border: path(['errors', 'institution'], this.state) ? "solid 1px #7f1414" : "none"
  })

  selectWithSearchStyle = {
    border: 'none'
  }

  isEditMode = () => Boolean(this.props.match.params.personal_id) //that means component is in 'edit' mode

  generateTypeOptions = () => {
    return [
      {value: '0100', label: 'Адміністративний персонал'},
      {value: '0200', label: 'Медичний персонал'},
      {value: '0300', label: 'Допоміжний персонал'},
      {value: '0400', label: 'Співробітники ДОЗ (Начальник відділу, головний спеціаліст, завідувач сектору і т.д.)'},
    ]
  }

  getValue = key => path(['personalData', key], this.state)

  getError = key => path(['errors', key], this.state)

  onValueChange = (value, key, errorValue = false) => {
    let createNewState = compose(assocPath(['personalData', key], value), assocPath(['errors', key], errorValue))
    this.setState(prevState => createNewState(prevState))
  }

  onChangeInstitution = institution => {
    if(!institution) institution = {value: ''}
    this.onValueChange(institution.value, 'institution')
    this.setState(() => ({institutionSelect: institution, editedSelect: true}))
  }

  onChangePersonal = personal => {
    if(!personal) personal = {value: ''}
    this.onValueChange(personal.value, 'doctor')
    this.setState(() => ({personalSelect: personal}))
  }

  onChangeType = type => {
    if(!type) type = {value: ''}
    this.onValueChange(type.value, 'personal_type')
  }

  onChangePriority = priority => this.onValueChange(priority.value || null, 'sort_priority')

  onChangePosition = event => this.onValueChange(event.target.value, 'position_title')

  onChangePhone = event => this.onValueChange(event.target.value, 'phone')

  onChangeCabinet = event => this.onValueChange(event.target.value, 'cabinet_number')

  onChangeSchedule = event => this.onValueChange(event.target.value, 'schedule')

  onChangeComment = event => this.onValueChange(event.target.value, 'comment')

  onChangeOperator = event => {
    this.onValueChange(event.target.checked, 'is_operator')
    this.onValueChange(event.target.checked, 'is_responsible')
  }

  onChangeAdmin = event => this.onValueChange(event.target.checked, 'is_admin')

  onChangeManagerInstitution = event => this.onValueChange(event.target.checked, 'is_manager_institution')

  onChangeRegistry = event => this.onValueChange(event.target.checked, 'is_registry')

  onSubmit = async (event) => {
    event.preventDefault()
    let requiredFields = ['personal_type', 'position_title', 'phone', 'doctor', 'institution']
    await this.validateForm(requiredFields)
    if(not(this.state.formValid)) return
    const personalId = path(['match', 'params', 'personal_id'], this.props)
    this.props.submitNewPersonal(this.state.personalData, personalId)
  }

  validateForm(requiredFields = null) {
    let fields = requiredFields ? pick(requiredFields, this.state.personalData) : this.state.personalData
    let errors = {}
    mapObjIndexed((value, key) => {
      let valueError = !value
      errors = assocPath([key], valueError, errors)
    }, fields)
    let isInvalid = value => Boolean(value)
    if(any(isInvalid, values(errors))) {
      this.setState(() => ({ errors, formValid: false }))
    } else {
      this.setState(() => ({ errors, formValid: true }))
    }
  }

  openModal = () => {
    const isFalse = value => Boolean(value)
    if(any(isFalse, values(this.state.personalData))){
      this.toggleModal()
      return
    }
    this.props.history.goBack()
  }

  toggleModal = () => this.setState(prevState => ({modalOpen: !prevState.modalOpen}))

  onModalOk = () => {
    this.toggleModal()
    this.props.history.goBack()
  }

  generatePersonalOptions = results => {
    return results.reduce((arr, item) => {
      const newOption =  {
        value: item.getIn(['id']),
        label: `${item.getIn(['user_data', 'last_name'])} ${item.getIn(['user_data', 'first_name'])} ${item.getIn(['user_data', 'middle_name'])} 
        (${item.getIn(['profession_classification_data', 'profession_title'])})`
      }
      arr.push(newOption)
      return arr
    }, [])
  }

  loadPersonal = (search = '') => {
    return this.props.loadDoctorList(search)
      .then(response => {
        const results = response.get('results')
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generatePersonalOptions(results)
        return { options }
      })
  }

  generateInstitutionOptions = results => {
    return results.reduce((arr, item) => {
      const newOption = {value: item.get('id'), label: item.get('full_title')}
      arr.push(newOption)
      return arr
    }, [])
  }

  loadInstitutions = (search = '') => {
    return this.props.loadInstitutions(search)
      .then(response => {
        const results = response.get('results')
        if(!results.size) return Promise.resolve({ options: [] })
        const options = this.generateInstitutionOptions(results)
        return { options }
      })
  }

  generatePriorityOptions = n => {
    const defaultValue = {value: '', label: 'Не визначено'}
    const arrayNumbers = Array.from(Array(n).keys(), key => ({value: key, label: key}));
    arrayNumbers[0] = defaultValue
    return arrayNumbers
  }


  componentDidMount () {
    let personalDetail = this.props.personalDetail
    if (personalDetail && this.props.match.params.personal_id) { //that means its 'edit' mode
      const keys = [
        'phone', 'personal_type', 'position_title',
        'is_admin', 'is_operator', 'is_manager_institution', 'is_responsible', 'is_manager_document', 'is_registry'
      ]
      const doctor = this.props.personalDetail.getIn(['doctor_data', 'id'])
      const institution = this.props.personalDetail.getIn(['institution_data', 'id'])
      let newState = { doctor, institution }
      const createNewState = key => {
        newState = {...newState, [key]: personalDetail.get(key)}
      }
      map(createNewState, keys)
      this.setState(() => ({
        personalData: newState,
        personalSelect:  {
          value: doctor,
          label: `${this.props.personalDetail.getIn(['user_data', 'last_name'])} ${this.props.personalDetail.getIn(['user_data', 'first_name'])} ${this.props.personalDetail.getIn(['user_data', 'middle_name'])}`
        },
        institutionSelect: {
          value: institution,
          label: `${this.props.personalDetail.getIn(['institution_data', 'full_title']) || 'Не визначено'}`
        }
      }))
    }

    if (this.props.match.params.personal_id) {
      this.props.loadPersonalDetail(this.props.match.params.personal_id)
    } else {
      this.props.cleanPersonalDetail();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.personalDetail && not(this.state.personalData.doctor) && nextProps.match.params.personal_id) { //that means 'edit' mode and props must be spread to state
      const doctor = nextProps.personalDetail.getIn(['doctor_data', 'id'])
      const institution = nextProps.personalDetail.getIn(['institution_data', 'id'])
      let newState = { doctor, institution}

      const keysData = ['phone', 'personal_type', 'position_title', 'schedule', 'comment', 'cabinet_number', 'sort_priority']
      const createNewDataState = key => {
        newState = {...newState, [key]: nextProps.personalDetail.get(key)}
      }
      map(createNewDataState, keysData)

      const keysRole = ['is_admin', 'is_operator', 'is_manager_institution', 'is_responsible', 'is_manager_document', 'is_registry']
      const createNewRoleState = key => {
        newState = {...newState, [key]: nextProps.personalDetail.get(key) || false}
      }

      map(createNewRoleState, keysRole)
      this.setState(() => ({
        personalData: newState,
        personalSelect:  {
          value: doctor,
          label: `${nextProps.personalDetail.getIn(['user_data', 'last_name'])} ${nextProps.personalDetail.getIn(['user_data', 'first_name'])} ${nextProps.personalDetail.getIn(['user_data', 'middle_name'])}`
        }
      }))
    }
    const firstProps = nextProps.personalDetail && not(this.state.personalData.institution) && not(this.state.editedSelect) && nextProps.match.params.personal_id
    if (firstProps) { //that means 'edit' mode and initial props must be spread to state
      const institution = nextProps.personalDetail.getIn(['institution_data', 'id'])

      this.setState(() => ({
        institutionSelect: {
          value: institution,
          label: `${nextProps.personalDetail.getIn(['institution_data', 'full_title']) || 'Не визначено'}`
        }
      }))
    }

    if(this.isEditMode() && not(this.state.isEditMode)){
      this.setState(() => ({isEditMode: true}))
    }
  }

  componentWillUnmount () {
    this.props.cleanPersonalDetail()
    this.props.cleanError()
  }

 
  render() {
    if (this.props.match.params.personal_id && !this.props.personalDetail.get('id')) return <Spinner/>

    return (
      <div>
        <PageHead>
          <h2>{this.props.match.params.personal_id ? "Редагувати інформацію про персонал" : "Додати персонал"}</h2>
        </PageHead>

        <Box title4={this.props.match.params.personal_id ? "Форма редагування інформації про персонал" : "Форма додавання персоналу"}>
          <form onSubmit={this.onSubmit}>

            <SelectWrapperAdmin>
              <Divider>
                <Label>Виберіть установу: <RequiredSpan hasError={this.getError('institution')}>*</RequiredSpan></Label>
                <SelectWithSearchAsync
                  searchable={true}
                  isSearchable={true}
                  onChange={this.onChangeInstitution}
                  value={this.state.institutionSelect}
                  loadOptions={this.loadInstitutions}
                  valueKey={'value'}
                  labelkey={'label'}
                  required
                  hasError={this.getError('institution')}
                  style={this.selectInstitutionStyle()}
                  placeholder="Починайте вводити для пошуку..."
                  noResultsText="Немає результатів"
                />
              </Divider>
            </SelectWrapperAdmin>

            <SelectWrapperAdmin>
              <Divider>
                <Label>Виберіть тип персоналу: <RequiredSpan hasError={this.getError('personal_type')}>*</RequiredSpan></Label>
                <SelectWithSearch
                  options={this.generateTypeOptions()}
                  searchable={true}
                  isSearchable={true}
                  value={this.getValue('personal_type')}
                  onChange={this.onChangeType}
                  required
                  hasError={this.getError('personal_type')}
                  style={this.selectTypeStyle()}
                  placeholder="Оберіть тип"
                  noResultsText="Немає результатів"
                />
              </Divider>
            </SelectWrapperAdmin>

            <SelectWrapperAdmin>
              <Divider>
                <Label>Виберіть обліковий запис: <RequiredSpan hasError={this.getError('doctor')}>*</RequiredSpan></Label>
                <SelectWithSearchAsync // source may change in future from doctor to all users
                  searchable={true}
                  isSearchable={true}
                  disabled = {this.isEditMode()}
                  isDisabled = {this.isEditMode()}
                  value={this.state.personalSelect}
                  onChange={this.onChangePersonal}
                  loadOptions={this.loadPersonal}
                  valueKey={'value'}
                  labelkey={'label'}
                  required
                  hasError={this.getError('doctor')}
                  style={this.selectPersonalStyle()}
                  placeholder="Починайте вводити для пошуку..."
                  noResultsText="Немає результатів"
                />
              </Divider>
            </SelectWrapperAdmin>

            <Input
              label="Номер телефону:"
              type="text"
              required
              max={255}
              placeholder="Введіть номер телефону"
              value={this.getValue('phone')}
              hasError={this.getError('phone')}
              onChange={this.onChangePhone}
            />

            <Input
              label="Посада:"
              required
              type="text"
              max={127}
              placeholder="Введіть посаду"
              value={this.getValue('position_title')}
              hasError={this.getError('position_title')}
              onChange={this.onChangePosition}
            />

            <Input
              label="Номер кабінету:"
              type="text"
              max={50}
              placeholder="Введіть номер кабінету"
              value={this.getValue('cabinet_number')}
              hasError={this.getError('cabinet_number')}
              onChange={this.onChangeCabinet}
            />

            <Textarea
              label="Графік прийому:"
              type="text"
              max={2000}
              placeholder="Введіть графік прийому"
              value={this.getValue('schedule')}
              hasError={this.getError('schedule')}
              onChange={this.onChangeSchedule}
            />

            <Textarea
              label="Додаткові відомості:"
              type="text"
              max={511}
              placeholder="Введіть додаткові відомості"
              value={this.getValue('comment')}
              hasError={this.getError('comment')}
              onChange={this.onChangeComment}
            />

            <Label>Порядок у списку:</Label>
            <SelectWithSearch
              options={this.generatePriorityOptions(100)}
              value={this.getValue('sort_priority') || ''}
              onChange={this.onChangePriority}
              style={ this.selectWithSearchStyle }
              placeholder="Визначте порядок у списку"
              noResultsText="Немає результатів"
            />

            <Checkbox
              type="checkbox"
              label="Оператор (робота з розсилками документів)"
              checked={this.getValue('is_operator') && this.getValue('is_responsible')}
              onChange={this.onChangeOperator}
            />

            <Checkbox
              type="checkbox"
              label="Адміністрація (відгуки, звернення, оцінки)"
              checked={this.getValue('is_manager_institution')}
              onChange={this.onChangeManagerInstitution}
            />

            <Checkbox
              type="checkbox"
              label="Реєстратура (запис до лікаря)"
              checked={this.getValue('is_registry')}
              onChange={this.onChangeRegistry}
            />

            <Checkbox
              type="checkbox"
              label="Адміністратор установи"
              checked={this.getValue('is_admin')}
              onChange={this.onChangeAdmin}
            />

            <ButtonDefault type="submit" value="Зберегти"/>
            <ButtonDefault onClick={this.openModal} value="Вийти без збереження"/>
          </form>

          {
            this.props.hasError && <Error>
              При збереженні даних виникла проблема. Перевірте, будь ласка, всі поля.
            </Error>
          }
        </Box>

        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                    className={{
                      base: 'modalContent',
                      afterOpen: 'myClass_after-open',
                      beforeClose: 'myClass_before-close'
                    }} contentLabel="Підтвердження запису"
                    overlayClassName={{
                      base: 'modalOverlay',
                      afterOpen: 'myOverlayClass_after-open',
                      beforeClose: 'myOverlayClass_before-close'
                    }}>
          <div>
            <Modal>
              <CloseModal>
                <div>
                  <img src={close} alt="закрити" onClick={this.toggleModal} />
                </div>
              </CloseModal>

              <ModalContent>
                <h3>
                  Ви впевнені, що хочете вийти без збереження?
                  Всі внесені зміни будуть скасовані
                </h3>
                <ButtonWrap>
                  <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                  <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                </ButtonWrap>
              </ModalContent>

            </Modal>
          </div>
        </ReactModal>

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePersonal);



// WEBPACK FOOTER //
// ./src/admin/personal/create.js